import { Tab, Tabs } from "@src/appV2/redesign/system/ui-components";

import { CaseStatuses } from "../constants";
import { type CaseStatus } from "../types";

interface CaseHistoryTabsProps {
  caseStatusFilter: CaseStatus;
  setCaseStatusFilter: React.Dispatch<React.SetStateAction<"OPEN" | "CLOSED">>;
  openCasesCount?: number;
  closedCasesCount?: number;
}

export function CaseHistoryTabs(props: CaseHistoryTabsProps) {
  const { caseStatusFilter, setCaseStatusFilter, openCasesCount, closedCasesCount } = props;

  return (
    <Tabs
      variant="pill"
      value={caseStatusFilter}
      sx={{ alignSelf: "center", my: 7 }}
      onChange={(_, newValue: CaseStatus) => {
        setCaseStatusFilter(newValue);
      }}
    >
      <Tab count={openCasesCount} variant="pill" label="Active cases" value={CaseStatuses.OPEN} />
      <Tab
        count={closedCasesCount}
        variant="pill"
        label="Closed cases"
        value={CaseStatuses.CLOSED}
      />
    </Tabs>
  );
}
